import { IAffairPub, IForMunicipalitiesApi } from '@api/affair.int';
import { TCoordinate, TGeoGroupLevel, TGeoGroupLevelAll } from '@api/api.int';
import { Box, Button, ButtonGroup, IconButton, Image } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { ILocation, isLocationGroup, isLocationGuard, useVVStore } from 'components/store';
import { VizvCard, VizvColumn } from 'components/vizvComponents';
import { useVVNav } from 'components/vvNav';
import { NavMain } from 'features/NavMain';
import geohash from 'ngeohash';
import { useEffect, useState } from "react";
import { MdArrowBack, MdArrowForward, MdMenu } from 'react-icons/md';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { IViewChangedEvent, MyMap, TMapSelectedItem } from "./MyMap";


export interface MapWrapperProps {

}


export function MapWrapper({ }: MapWrapperProps) {
	const store = useVVStore();

	const [filteredItems, setFilteredItems] = useState<ILocation[]>([]);
	const [createCoordinate, setCreateCoordinate] = useState<TCoordinate | undefined>();
	const [selectedAffair, setSelectedAffair] = useState<IAffairPub>()
	const [mapSelectedItem, setMapSelectedItem] = useState<TMapSelectedItem | undefined>();

	const api = useVVApi();




	// ================================ CREATE ==========================
	const location = useLocation();
	const isLocationMap = location.pathname === '/map' || location.pathname === '/map/';
	const vvNav = useVVNav();
	const onItemClick = (orig: any) => {
		onCancel();
		if (orig.affairKey) {
			setMapSelectedItem(orig as IAffairPub);
			vvNav.toDetail('/affair/' + orig.affairKey);
		}
	}

	const onCancel = () => {
		setCreateCoordinate(undefined);
		setSelectedAffair(undefined);
		vvNav.toRoot();
	}


	// ========================================== MAP VIEW CHANGED =========================================
	const [inBoxInfo, setInBoxInfo] = useState('');
	const [view, setView] = useState<IViewChangedEvent>();
	useEffect(() => {
		//console.log('WRAPPER:useEffect()');
		if (!view /*|| store.mapMode === 'SELECT'*/)
			return;

		(async () => {
			let level: TGeoGroupLevelAll = 'Location';
			let filteredGroups : TGeoGroupLevel[] = [];
			let geoHashPrec = 4;
			if (view.zoom <= 9.5) {
				level = 'Region';
				filteredGroups = ['Region', 'Municipality-Region']
				geoHashPrec = 3;
			} else if (view.zoom <= 11) {
				level = 'SubRegion';
				filteredGroups = ['SubRegion', 'SubMunicipality']
				geoHashPrec = 4;
			} else if (view.zoom <= 12.5) {
				level = 'Municipality';
				filteredGroups = ['Municipality', 'SubMunicipality']				
				geoHashPrec = 4;
			}

			if (level === 'Location') {
				const boxes = geohash.bboxes(view.lat1, view.lng1, view.lat2, view.lng2, geoHashPrec);
				const keysArr = new Array<string>();
				for (let group of store.groupList) {
					if (['Municipality', 'SubMunicipality'].indexOf(group.geoGroupLevel)===-1)
						continue;
					if (store.loadedMunicipalities.indexOf(group.groupKey) !== -1)
						continue;
					if (store.loadingMunicipalities.indexOf(group.groupKey) !== -1)
						continue;
					for (let b of boxes) {
						if (group.geoHash.startsWith(b)) {
							keysArr.push(group.groupKey);
							break;
						}
					}
				}

				if (keysArr.length > 0 ) {
					console.log('LOADING KEYS::', keysArr);
					store.addLoadingMunicipalities(keysArr);
					const keys = keysArr.join(';');
					try {
						const resp = await api.fetchToast<IForMunicipalitiesApi>({
							url: '/affair/for-municipalities', method: 'GET',
							query: { m: keys }
						});
						store.removeLoadingMunicipalities(keysArr);
						store.addLoadedMunicipalities(keysArr);
						store.addAffairItems(resp.affairs);
						store.addGuardItems(resp.guards);
						
					} catch (err) { }
				}
			} 
			//console.log('_-----------FILTER', filteredGroups);
			const _filtered = store.itemsList.filter(i => (isLocationGroup(i) && filteredGroups.indexOf(i.dbGroup.geoGroupLevel) !==-1) || (!isLocationGroup(i) && level === 'Location'));
			//console.log('FILTERED', _filtered.find(u => isLocationGuard(u) && u.dbGuard.userKey === 'usr1742121948396') || 'not found');
			setFilteredItems(_filtered);
			setInBoxInfo(`zoom: ${Math.round(view.zoom * 10) / 10} geoPrec: ${geoHashPrec} level: ${level} items: ${_filtered.length}`);

		})();
	}, [view?.zoom, view?.lat1, view?.lng1, store.mapMode, store.itemsList, store.loadedMunicipalities]);

	const onViewChanged = (evt: IViewChangedEvent) => {
		setView(evt);

	}

	// ================================ PATH & ORIENTATION ==========================

	const path = location.pathname;

	useEffect(() => { // TODO:  EZ ÍGY MEKKORA SPAGETTI SZAR!!!!
		/*if (!path.startsWith('/create') && !path.startsWith('/profile/guard-set/location') && !path.startsWith('/profile/guard-set/location') && store.suggestionList.length > 0)
			store.setSuggestionList([]);*/
		if (!path.startsWith('/create') && !path.startsWith('/profile/guard-set/location') && store.mapMode !== 'SHOW')
			store.setMapMode('SHOW');
		if (isLocationMap && mapSelectedItem)
			setMapSelectedItem(undefined);
	}, [path, store.mapMode, mapSelectedItem])

	const showDebug = false;


	const isMobile = store.isMobile();
	const isFull = store.isFull();
	const [isMapOverlay, setIsMapOverlay] = useState(true);

	useEffect(() => {
		let v = false;
		if (store.isMobile()) {
			v = store.layoutPush === 'no' || (!store.isTools());
		} else {
			v = !isLocationMap && (!store.isTools()  || ( store.isTools() && store.isToolDetailed()));
		}
		setIsMapOverlay(v);
	}, [store.isMobile(), store.isTools(), store.layoutPush, isLocationMap, store.isToolDetailed() ])

	let LAYOUT_LEFT = '0';
	if (store.layoutPush === 'menu') {
		LAYOUT_LEFT = '-'+ store.getMenuWidth();// '-100vw';
		//isMapOverlay = isMobile;
	} else if (store.layoutPush === 'menu_and_tools') {
		LAYOUT_LEFT = `calc( -${store.getMenuWidth()} - ${store.getToolsWidth()})`;
		//isMapOverlay = isMobile;
	}



	useEffect(() => {
		if (!isMobile && !store.isTools() && store.layoutPush !== 'no')
			store.setLayoutPush('no');

	}, [isMobile, store.isTools(), store.layoutPush]);

	return <>
		<MyMap
			onItemClick={onItemClick}
			locations={filteredItems}
			onViewChanged={onViewChanged}
			selected={mapSelectedItem}
		/>
		{true && <Box className='vizv-map-overlay-1' position='fixed' inset={0}
			pointerEvents='none'
			css={{'touch-action':'none'}}
			transition='background-color .4s'
			{...isMapOverlay && {
				//backdropFilter: 'grayscale(.65) blur(2px)',
				backdropFilter: 'grayscale(.85) brightness(0.8)',
				background: '#fff3',
				pointerEvents:'initial',
				css:{'touch-action':'none'}
			}}
		/>}




		<Box className='vizv-main-layout' id='vizv-main-layout'
			position='fixed' //display='none'
			inset={0}
			//width='100vw' height='100vh'
			overflow='hidden'
			pointerEvents={isMapOverlay?'initial':'none'}
			css={{'touch-action': isMapOverlay?'initial':'none'}}
		>
			<Box className='vizv-main-layer'
				height='100vh'
				position='relative'
				display='flex' flexDir='row' alignItems='stretch' justifyContent='flex-start'
				transition='left .2s ease-out'
				left={LAYOUT_LEFT}
			>
				<VizvColumn className='vizv-col-menu' background={showDebug ? '#f004' : undefined}
					width={store.getMenuWidth()}
				>
					<NavMain />
				</VizvColumn>
				<Outlet />
				{isMobile && store.isTools() && <VizvColumn p={1}>
					<VizvCard display='flex' flexDir='row' p={2}>
						<Button leftIcon={<MdArrowBack />} aria-label="menu" size='sm' fontWeight='400' variant='ghost' onClick={() => store.setLayoutPush('menu')} >Vissza</Button>
						<Image src='/logo/vizvedok_neg2.png' height='30px' onClick={() => store.setLayoutPush('menu')} cursor='pointer' />
					</VizvCard>
					</VizvColumn>}
			</Box>
		</Box>

		<Box position='fixed' left={0} bottom={0} bg='black' fontSize='sm' p={1} gap={1} display='none' flexDir='column'>
			<ButtonGroup size='xs'>
				<Button onClick={() => store.setLayoutPush('no')}>no</Button>
				<Button onClick={() => store.setLayoutPush('menu')}>menu</Button>
				{store.isTools() && store.isToolDetailed() && <Button onClick={() => store.setLayoutPush('menu_and_tools')}>m+tool</Button>}
			</ButtonGroup>
			<Box>
				{isMobile && 'sm'}{isFull && 'lg'}{!isMobile && !isFull && 'md'}
				&nbsp;push:{store.layoutPush} / left:{LAYOUT_LEFT} / tools:{store.__toolsWidthPx}({JSON.stringify(store.isTools())}) / detail: {JSON.stringify(store.isToolDetailed())}
				/ overl: {JSON.stringify(isMapOverlay)}
			</Box>
			{/* 
			<Box>{store.loadingMunicipalities.join("; ")}</Box>
			<Box>{location.pathname} {JSON.stringify(isLocationMap)}</Box>
			*/}

		</Box>

	</>
}

